"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Reward_1 = __importDefault(require("../../../Icons/Notifications/Reward"));
var NotificationItem_1 = __importDefault(require("../../NotificationItem"));
var utils_1 = require("../../utils");
var NotificationItemNFTLink_1 = __importDefault(require("../../NotificationItemNFTLink"));
var config_1 = require("../../../../config");
var i18N = {
    en: {
        description: function (reward) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "We're working on delivering your",
            react_1.default.createElement(NotificationItemNFTLink_1.default, { rarity: reward.tokenRarity, name: reward.tokenName, link: config_1.config.get('EXPLORER_URL') }),
            "as soon as possible.")); },
        title: 'Your Gift is Delayed'
    },
    es: {
        description: function (reward) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "Estamos trabajando en entregar tu",
            react_1.default.createElement(NotificationItemNFTLink_1.default, { rarity: reward.tokenRarity, name: reward.tokenName, link: config_1.config.get('EXPLORER_URL') }),
            "lo antes posible.")); },
        title: 'Tu regalo está retrasado'
    },
    zh: {
        description: function (reward) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "\u6211\u4EEC\u6B63\u5728\u5C3D\u5FEB\u4EA4\u4ED8\u60A8\u7684",
            react_1.default.createElement(NotificationItemNFTLink_1.default, { rarity: reward.tokenRarity, name: reward.tokenName, link: config_1.config.get('EXPLORER_URL') }),
            "\u3002")); },
        title: '您的礼物延迟了'
    }
};
/**
 * @deprecated Should start using the same component migrated to UI2.
 */
function RewardDelayedNotification(_a) {
    var notification = _a.notification, locale = _a.locale;
    return (react_1.default.createElement(NotificationItem_1.default, { image: {
            image: notification.metadata.tokenImage,
            backgroundColor: (0, utils_1.getBGColorByRarity)(notification.metadata.tokenRarity),
            icon: react_1.default.createElement(Reward_1.default, null)
        }, timestamp: notification.timestamp, isNew: !notification.read, locale: locale },
        react_1.default.createElement("p", { className: "dcl notification-item__content-title" }, i18N[locale].title),
        react_1.default.createElement("p", { className: "dcl notification-item__content-description" }, i18N[locale].description(notification.metadata))));
}
exports.default = RewardDelayedNotification;
